import { newLayout } from 'theme';

export const COLORS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

export const SIZES = {
  THIN: 'thin',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export const VARIANTS = {
  ELEVATION: 'elevation',
  OUTLINED: 'outlined',
};

export const CARD_HEADER_SIZE = {
  SMALL: newLayout.fontSize.h4,
  MEDIUM: newLayout.fontSize.h3,
  LARGE: newLayout.fontSize.h2,
};
